import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '@env/environment';
import { PortalApiService } from '../modules/portal/services/portal-api.service';

@Injectable()
export class PortalGuard implements CanActivate {

    constructor(
        private router: Router,
        private portalApi: PortalApiService,
    ) {}

    canActivate(): Observable<boolean | UrlTree> {
        const isCustomDomain = location.origin !== environment.envVar.APP_URL;

        if (!isCustomDomain) {
            return of(this.router.createUrlTree(['/login']));
        }

        return this.portalApi.getPortalByDomain(location.origin).pipe(
            map(data => {
                if (data && data.isActive) {
                    return true;
                }
                return this.router.createUrlTree(['/login']);
            }),
            catchError(() => of(this.router.createUrlTree(['/login'])))
        );
    }
}
